import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { ThinXMark } from "@/assets/images";

import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  Input,
} from "@/components/ui";

type PhoneConfirmationDrawerProps = {
  isOpen: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  cancel: () => void;
  handleSubmit: () => void;
  apiError: string | undefined;
  setValidationError: Dispatch<SetStateAction<string | null>>;
  validationError: string | null;
  setCode: Dispatch<SetStateAction<string>>;
  code: string;
};

const PhoneConfirmationDrawer = ({
  isOpen,
  onOpenChange,
  cancel,
  handleSubmit,
  apiError,
  setValidationError,
  validationError,
  setCode,
  code,
}: PhoneConfirmationDrawerProps) => {
  const { t } = useTranslation();

  return (
    <Drawer onOpenChange={onOpenChange} open={isOpen}>
      <DrawerContent className="text-secondaryText">
        {" "}
        <div className="mx-auto w-full p-6">
          <DrawerHeader>
            <DrawerTitle>
              <div className="mb-4 flex flex-row gap-3">
                <DrawerClose asChild>
                  <img src={ThinXMark} alt="close" className="min-h-6 min-w-6 cursor-pointer" />
                </DrawerClose>
                <h3 className="text-lg font-normal text-gray-600">{t("phoneConfirmation.confirmPhoneNumber")}</h3>
              </div>
            </DrawerTitle>
          </DrawerHeader>
          <Input
            className="text-base"
            value={code}
            onChange={(e) => {
              const newValue = e.target.value;
              if (!/^\d*$/.test(newValue) || newValue.length > 6) {
                setValidationError(t("phoneConfirmation.validationError"));
              } else {
                setValidationError(null);
                setCode(newValue);
              }
            }}
          ></Input>
          {validationError && <div className="text-redApp">{validationError}</div>}
          {apiError && <div className="text-redApp">{apiError}</div>}
          <div className="py-3 text-secondaryText">{t("phoneConfirmation.validFor")}</div>
          <DrawerFooter className="flex w-full gap-2">
            <DrawerClose asChild>
              <Button className="text-secondaryText" onClick={cancel}>
                {t("phoneConfirmation.cancel")}
              </Button>
            </DrawerClose>
            <Button variant="yellow" className="grow" onClick={handleSubmit}>
              {t("phoneConfirmation.continue")}
            </Button>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export { PhoneConfirmationDrawer };
